import { Injectable } from '@angular/core';
import { Observable,Subject,BehaviorSubject } from "rxjs";

import { FilterLeftPadd } from "src/app/shared/filter";

@Injectable({providedIn: 'root'})
export class FvmsCommonService {
    private readonly nameCompanyInfo:string = "companyInfo";
    private readonly nameDateTimeInfo:string = "dateTimeInfo";
    private readonly fromTimeReserve:string = "00:00:00"
    private readonly toTimeReserve:string = "23:59:59"
    private readonly driverGroupIdArrStr:string = "1000,99999" //운전자 groupId 배열. 현재는 1000번만 조회. 1001번은 테스트 groupId. 해당되는 데이터 없음. 필요 시 콤마 구분자로 추가 가능

    //subject는 페이지 이동시 subscribe가 바로 실행되지 않음
    //BehaviorSubject는 페이지 이동시 마지막값을 변경된 값으로 인식해서 바로 실행됨
    subjectCompanyInfo:Subject<any> = new Subject<any>();
    // subjectCompanyInfo:BehaviorSubject<any> = new BehaviorSubject<any>(null);
    // subjectCompanyInfo:BehaviorSubject<any> = new BehaviorSubject<any>({
    //     companyId : -1
    //     ,companyNm : ""
    //     ,dtgEid:""
    //     ,pCompanyId : 1
    //     ,pCompanyNm : ""
    // });
    subjectDateTimeInfo:Subject<any> = new Subject<any>();
    isLoading:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    subjectSearchKeyword:Subject<string> = new Subject<string>();
    subjectToggleSideMenu:Subject<any> = new Subject<any>();

    constructor() {
        let companyInfoSrc = sessionStorage.getItem(this.nameCompanyInfo);
        if(companyInfoSrc){
            //this.subjectCompanyInfo.next(JSON.parse(companyInfoSrc));
        }

        let dateTimeInfoSrc = sessionStorage.getItem(this.nameDateTimeInfo);
        if(!dateTimeInfoSrc){
            let dateTimeCurr = new Date();
            let dateTimeInfo = {
                fromDate : { //NgbDate
                    year : dateTimeCurr.getFullYear()
                    ,month : dateTimeCurr.getMonth() + 1
                    ,day : dateTimeCurr.getDate()
                }
                ,toDate : { //NgbDate
                    year : dateTimeCurr.getFullYear()
                    ,month : dateTimeCurr.getMonth() + 1
                    ,day : dateTimeCurr.getDate()
                }
                ,fromTime : "00:00:00" //시간까지 선택으로 바뀌면 사용
                ,toTime : "23:59:59" //시간까지 선택으로 바뀌면 사용
            };
            sessionStorage.setItem(this.nameDateTimeInfo,JSON.stringify(dateTimeInfo));
            //this.subjectDateTimeInfo.next(dateTimeInfo);
        }else{
            //this.subjectDateTimeInfo.next(JSON.parse(dateTimeInfoSrc));
        }
    }

  

    //보관중인 마지막값을 리턴
    getCompanyInfo(){
        let companyInfo = sessionStorage.getItem(this.nameCompanyInfo);
        if(companyInfo) {
            return JSON.parse(companyInfo);
        }
        return null;
    }
    //마지막 값을 설정 -> 구독중인 모든 컴포넌트가 각자 행동취함
    setCompanyInfo(companyInfo:any){
        if(companyInfo){
            sessionStorage.setItem(this.nameCompanyInfo,JSON.stringify(companyInfo));
            this.subjectCompanyInfo.next(companyInfo);
        }
    }
    //구독
    subscribeCompanyInfo():Observable<any>{
        // return this.subjectCompanyInfo.asObservable();
        return this.subjectCompanyInfo;
    }

    getDateInfo(){
        let dateTimeInfo = sessionStorage.getItem(this.nameDateTimeInfo);
        if(dateTimeInfo) {
            return JSON.parse(dateTimeInfo);
        }
        return null;
    }
    setDateInfo(dateTimeInfo:any){
        if(dateTimeInfo){
            sessionStorage.setItem(this.nameDateTimeInfo,JSON.stringify(dateTimeInfo));
            this.subjectDateTimeInfo.next(dateTimeInfo);
        }
    }
    subscribeDateInfo():Observable<any>{
        return this.subjectDateTimeInfo.asObservable();
    }

    getDayDiff(){

        let diffDate_1 = new Date(this.getDateFromYmd());
        let diffDate_2 = new Date(this.getDateToYmd());
   
        diffDate_1 =new Date(diffDate_1.getFullYear(), diffDate_1.getMonth()+1, diffDate_1.getDate());
        diffDate_2 =new Date(diffDate_2.getFullYear(), diffDate_2.getMonth()+1, diffDate_2.getDate());
    
        let diff = Math.abs(diffDate_2.getTime() - diffDate_1.getTime());
        diff = Math.ceil(diff / (1000 * 3600 * 24));
        
        return diff+1;

    }
    
    getDateFromYmd(){
        let dateTimeInfo = this.getDateInfo();
        let filterLeftPadd = new FilterLeftPadd();
        let yy = filterLeftPadd.transform(dateTimeInfo.fromDate.year,4);
        let mm = filterLeftPadd.transform(dateTimeInfo.fromDate.month,2);
        let dd = filterLeftPadd.transform(dateTimeInfo.fromDate.day,2);
        return `${yy}-${mm}-${dd}`;
    }
    getDateToYmd(){
        let dateTimeInfo = this.getDateInfo();
        let filterLeftPadd = new FilterLeftPadd();
        let yy = filterLeftPadd.transform(dateTimeInfo.toDate.year,4);
        let mm = filterLeftPadd.transform(dateTimeInfo.toDate.month,2);
        let dd = filterLeftPadd.transform(dateTimeInfo.toDate.day,2);
        return `${yy}-${mm}-${dd}`;
    }
    getDateFromIso(){
        let ymd = this.getDateFromYmd();
        let dateTimeInfo = this.getDateInfo();
        return `${ymd} ${dateTimeInfo.fromTime}`;
    }
    getDateToIso(){
        let ymd = this.getDateToYmd();
        let dateTimeInfo = this.getDateInfo();
        return `${ymd} ${dateTimeInfo.toTime}`;
    }
    getDateFromIsoReserve(){
        let ymd = this.getDateFromYmd();
        let dateTimeInfo = this.getDateInfo();
        return `${ymd} ${this.fromTimeReserve}`;
    }
    getDateToIsoReserve(){
        let ymd = this.getDateToYmd();
        let dateTimeInfo = this.getDateInfo();
        return `${ymd} ${this.toTimeReserve}`;
    }
    getFromTimeReserve(){
        return this.fromTimeReserve;
    }
    getToTimeReserve(){
        return this.toTimeReserve;
    }
    
    getIsLoading(){
        return this.isLoading.getValue();
    }
    setIsLoading(isLoading:boolean){
        this.isLoading.next(isLoading);
    }
    subscribeIsLoading():Observable<any>{
        return this.isLoading.asObservable();
    }
    getDriverGroupIdArrStr():string{
        return this.driverGroupIdArrStr;
    }
    subscribeSearchKeyword():Observable<string>{
        // return this.subjectCompanyInfo.asObservable();
        return this.subjectSearchKeyword
    }
    setSearchKeyword(searchKeyword:string){
        this.subjectSearchKeyword.next(searchKeyword);
    }

    setToggleSideMenu(item:any){
        this.subjectToggleSideMenu.next(item);
    }

    subscribeToggleSideMenu():Observable<any>{
        return this.subjectToggleSideMenu;
    }
}